import trackGoal from 'utils/metrika'

const RELEASE_METRIC_PREFIX = 'release_notes'

const compact = (payload = {}) =>
  Object.entries(payload).reduce((acc, [key, value]) => {
    if (value === null || value === undefined || value === '') return acc
    acc[key] = value
    return acc
  }, {})

export const trackReleaseEvent = (eventName, payload = {}) =>
  trackGoal(`${RELEASE_METRIC_PREFIX}_${eventName}`, compact(payload))
